import * as Long from "long";
import { IdResource } from "../../../../constants/IdResource";
import { selectAndApplyActiveBuildingBuffedCost } from "../../../../selectors/selectBuffsInfo";
import { selectBuildingStageInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
export var checkBuildingPurchaseHasEnoughResourcePremium = function (path) { return function (action, state$) {
    var building = action.building, premium = action.premium;
    var initialStageInfo = selectBuildingStageInfo(building, 0);
    if (premium && initialStageInfo && initialStageInfo.premium) {
        var goldCost = initialStageInfo.premium.cost.find(function (cost) { return cost.resourceId === IdResource.Gold; });
        var goldAmount = selectAndApplyActiveBuildingBuffedCost(state$.value, action.building.balancing.id, IdResource.Gold, goldCost.amount);
        var playerGold = selectInventoryResourceInfo(state$.value, IdResource.Gold);
        if (playerGold.amount.lessThan(Long.fromValue(goldAmount))) {
            return path;
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingPurchaseHasEnoughResourcePremium.ts
// module id = 2061
// module chunks = 3